import React from "react";

//component ================  
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx"; 
import CardContent from '@material-ui/core/CardContent'; 

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel' ;
import TextField from '@material-ui/core/TextField';
import Checkbox from "@material-ui/core/Checkbox";
import CardIcon from "components/Card/CardIcon" 
import CardHeader from "components/Card/CardHeader"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import FormLabel from "@material-ui/core/FormLabel"

import { compose } from "recompose"
import { connect } from "react-redux"
import { updateAnswers } from "store/actions"
import FadeIn from 'react-fade-in';
import { replaceNumberQuestion } from "helpers/ConvertString"

import { countKey } from "helpers/ObjectHelp"

//icon ============
import Check from "@material-ui/icons/Check"; 
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import withStyles from "@material-ui/core/styles/withStyles";

import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle.jsx";

const styles = {
  ...regularFormsStyle,  
}
class QInputComponent extends React.Component {
    constructor(props) {
      super(props)
      this.state = {   
        countUpdate:0,
        headerLabel:this.props.headerLabel,
        language:this.props.language, 
        dataQuestion:this.props.dataQuestion, 
        sectionName:this.props.sectionName, 
        questionName:this.props.questionName,
        value:this.props.value,
        questionCommentWording:this.props.questionCommentWording, 
        answers:{}, 
      }
    } 
    componentDidMount(){
      if(this.state.value[this.state.sectionName] && this.state.value[this.state.sectionName][this.state.questionName]){
        this.setState({answers:this.state.value[this.state.sectionName][this.state.questionName]})
      }
    }
    handleChangeSelect = (name,value,callback) => {
      if(value === ""){
        if(callback)callback()
        return
      }
      this.setState({
        [name]: value,
      },()=>{
       
      });
    };
    handleChangeAnswer = (e) => {   
      var answers = this.state.answers;  
      answers.type = this.state.dataQuestion.type 
      answers.value = e.target.value    
      this.setState({
        answers:answers
      },()=>{
        this.props.updateAnswersCallback(this.state.sectionName,this.state.questionName,answers,()=>{ 
          this.setState({countUpdate:++this.state.countUpdate})
        })
      })
    }; 
       
    render() {  
      const { classes } = this.props;
      return (   
        <Card className="card-bg-90">
          {
            (this.state.headerLabel)?
            <CardHeader color="info" icon>
              <CardIcon color="danger" className="icon-question">
                <span className="title-question">{this.state.headerLabel}</span>
              </CardIcon> 
            </CardHeader>
            :""
          } 
          <CardContent> 
            <div className="m-b-2"> 
            {!this.props.hideNumberQuestion?
              <span className="m-r-2 W100">
                {replaceNumberQuestion(this.state.questionName)+")"}
              </span>
              :""
            }
              {this.state.dataQuestion[this.state.language]["question"+(this.props.isScriptAgent?"_agent":"")]} 
            </div>
            {
              (this.state.questionTitleDescription)?
                <div className="m-l-8 mlt-txt"><b>{this.state.questionTitleDescription[this.state.language]}</b></div>
              :""
            } 
            <div className="m-l-8">
              <GridContainer> 
                <GridContainer className="note-input-QInput"> 
                  <GridItem xs={"11"}>
                    <CustomInput 
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        rows:4,
                        multiline :true, 
                        type: "text",
                        value: this.state.answers.value,
                        placeholder: "ระบุช่องนี้",
                        onChange: this.handleChangeAnswer 
                      }}
                    />
                  </GridItem>
                </GridContainer> 
              </GridContainer>
            </div>  
             
          </CardContent>
        </Card> 
      );
    }
}

function mapStateToProps({ answers }) { 
  return {
    answers: answers
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { updateAnswers }
  )
)(QInputComponent)